import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { VideoStatus } from '@modules/media/models/media-video.model';
import { StreamService } from '@modules/shared/services/stream.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'mb-stream-player-error',
  templateUrl: './stream-player-error.component.html',
  styleUrls: ['./stream-player-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StreamPlayerErrorComponent implements OnInit, OnDestroy {
  @Input() errorText!: string | undefined;
  @Input() streamId!: string;
  @Input() streamStatus!: string;

  @Output() closeStreamPlayer = new EventEmitter<void>();
  @Output() streamErrorData = new EventEmitter<{ errorText: string; showErrorScreen: boolean }>();

  private stopPoll$ = new Subject<boolean>();

  constructor(private streamService: StreamService) {}

  ngOnInit(): void {
    if (this.streamStatus === VideoStatus.LIVE) {
      this.pollForStatus();
    }
  }

  public reloadPlayer(): void {
    this.stopPoll$.next(true);
    this.pollForStatus();
  }

  public closePlayer(): void {
    this.closeStreamPlayer.emit();
  }

  private pollForStatus(): void {
    this.streamService
      .pollPlayerStatusForStream(this.streamId, this.stopPoll$)
      .pipe(takeUntil(this.stopPoll$))
      .subscribe((data) => {
        if (data) {
          const { errorText, showErrorScreen } = data;
          this.streamErrorData.emit({ errorText, showErrorScreen });
        }
      });
  }

  ngOnDestroy(): void {
    this.stopPoll$.next(true);
    this.stopPoll$.complete();
  }
}
